import { ReactComponent as CognusLogo } from 'assets/svg/LogoPortalNew.svg'
// import { ReactComponent as LinkedInLogo } from 'assets/svg/LinkedIn.svg'
import Typography from '../../../components/Typography/Typography'
type TProps = {
  scroll: (link: string) => void
}

// const url = 'https://www.linkedin.com/company/cognushealth/about/'
const Footer = ({ scroll }: TProps) => {
  // const handleLink = () => {
  //   window.open(url)
  // }
  return (
    <div className="landing-page__footer row space-between full-width">
      <CognusLogo className="landing-page__footer__logo" />
      <div className="landing-page__footer__links column">
        <Typography.Headline6 onClick={() => scroll('about')}>
          About
        </Typography.Headline6>
        <Typography.Headline6 onClick={() => scroll('who-we-serve')}>
          Who we serve
        </Typography.Headline6>
        <Typography.Headline6 onClick={() => scroll('contact-us')}>
          Contact us
        </Typography.Headline6>
      </div>
      <div className="landing-page__footer__info column">
        <Typography.Label>
          Owens & Minor
          <br />
          Attn: General Counsel
          <br /> 9120 Lockwood Boulevard
          <br /> Mechanicsville, VA 23116
        </Typography.Label>
        <Typography.Label className="landing-page__footer__info__mail">
          <a href="mailto:support@community.ominnovations.health">
            support@community.ominnovations.health
          </a>
        </Typography.Label>
        {/*<LinkedInLogo onClick={handleLink} />*/}
      </div>
    </div>
  )
}

export default Footer
